<template>
  <div class="maintenance-container">
    <Card class="maintenance-card">
      <template #title>
        <div class="text-center">
          <i class="pi pi-cog pi-spin" style="font-size: 3rem"></i>
          <h2 class="mt-3">Sistema em Manutenção</h2>
        </div>
      </template>
      <template #content>
        <p class="text-center">Estamos a realizar melhorias no sistema. Prometemos ser rápidos!</p>
      </template>
    </Card>
  </div>
</template>

<script>
export default {
  name: 'Maintenance'
}
</script>

<style scoped>
.maintenance-container {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f4f4f4;
}
.maintenance-card {
  width: 400px;
  text-align: center;
}
.text-center {
  text-align: center;
}
</style>
